/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.triggerGeofence

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.triggerGeofence.TriggerGeofencesApi
import features.triggerGeofence.models.TriggerGeofenceResponseModel
import features.triggerGeofence.serializeTriggerGeofencesState
import features.triggerGeofence.models.TriggerGeofenceRequest

import kotlinx.serialization.decodeFromString

/**
 * Trigger a geofence event. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("TriggerGeofencesApi")
class TriggerGeofencesApiJs {

    /**
     * Trigger a geofence event.
     */


    
    fun triggerGeofence(overrideHeaders: String?,
serializedTriggerGeofenceRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = TriggerGeofencesApi().triggerGeofence(
            overrideHeaders = decodedOverrideHeaders,
                triggerGeofenceRequest = Json.decodeFromString(
                    serializedTriggerGeofenceRequest
                )
            ).toJsonResult<TriggerGeofenceResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeTriggerGeofencesState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        TriggerGeofencesApi().triggerGeofencesState.serializeTriggerGeofencesState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
